import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, text } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);
const g = { v: 'Validace', d: 'Default' };

stories
	.addDecorator(withKnobs)
	.add('Color picker ', () => ({
		template: `
		<dms-form :model="$data" :rules="rules">
			<dms-color-picker v-bind="$props" validationProperty="value" :value.sync="value" />
		</dms-form>
		`,
		data() {
			return {
				value: 16711680, // red color in decimal
			};
		},
		props: {
			label: {
				default: text('Label', 'Barva', g.d),
			},
			isRequired: {
				default: boolean('Povinné pole', true, g.d),
			},
			disabled: {
				default: boolean('Disabled', false, g.d),
			},
		},
		computed: {
			rules() {
				const rules = [
					{
						required: this.isRequired, trigger: ['change', 'blur'],
					},
				];

				return {
					value: rules,
				};
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
